import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { Dotcom2024Service } from '../dotcom2024.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MyharrellsService } from '../myharrells.service';

@Component({
  selector: 'app-careers',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './careers.component.html',
  styleUrl: './careers.component.css'
})
export class CareersComponent {

  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";
  pageImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/Careers/";

  thirdPartyJobPostings: any[] = [];

  jobToDisplay: string = "";

  constructor(public myHarrellsService: MyharrellsService, private title: Title, private meta: Meta, public dotComService: Dotcom2024Service, public router: Router, public route: ActivatedRoute) { }

  ngOnInit() {

    //meta tags for SEO
    this.title.setTitle("Careers at Harrell’s | Join Our Growing Team");
    this.meta.updateTag({ name: 'description', content: "Explore careers at Harrell’s! We offer opportunities in sales, customer service, operations, trucking, and more. View open positions and apply today!" });
    this.meta.updateTag({ property: 'og:title', content: "Careers at Harrell’s | Join Our Growing Team" });
    this.meta.updateTag({ property: 'og:description', content: "Explore careers at Harrell’s! We offer opportunities in sales, customer service, operations, trucking, and more. View open positions and apply today!" });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - careers" });
    // this.meta.updateTag({ property: 'og:url', content: "Explore careers at Harrell’s! We offer opportunities in sales, customer service, operations, trucking, and more. View open positions and apply today!" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Careers at Harrell’s | Join Our Growing Team" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Careers at Harrell’s | Join Our Growing Team" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Careers at Harrell’s | Join Our Growing Team" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Explore careers at Harrell’s! We offer opportunities in sales, customer service, operations, trucking, and more. View open positions and apply today!" });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - careers" });
    // this.meta.updateTag({ name: 'author', content: "author tag here - careers" });


    //this gives you the content provided by our third party hr resource
    //if you search on "theapplicantmanager" in the code you will see where this is used
    if (typeof document !== 'undefined') {
      let appMgrDOM = document.getElementById("theapplicantmanager");
      let ctr = appMgrDOM.getElementsByClassName('title').length;

      for (let index = 0; index < appMgrDOM.getElementsByClassName('title').length; index++) {
        const title = (appMgrDOM.getElementsByClassName('title')[index] as HTMLElement).innerText;
        const description = (appMgrDOM.getElementsByClassName('description')[index] as HTMLElement).innerText;
        const applyURL = appMgrDOM.getElementsByClassName('title')[index].firstChild.toString()
        
        this.thirdPartyJobPostings.push({ title: title, description: description, applyURL: applyURL });
      }
    }
  }

  ToggleExpand(jobTitle: string) {
    if (this.jobToDisplay == jobTitle) {
      this.jobToDisplay = "";
    }
    else {
      this.jobToDisplay = jobTitle;
    }

  }

}
